export default {
    namespaced: true,
    state: () => ({
        authlist: []
    }),
    mutations:
    {
        SET_AUTHLIST(state, val) {
            state.authlist = val
        },
    }
}